const translates = {
	en: {
		comment: 'Edit comment'
	},
	ru: {
		comment: 'Редактировать комментарий'
	}
};
export default translates;